/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './App.scss';

import { Provider } from 'react-redux';

import { ExternalAppProviders } from 'shared-ui/external-app-base';

import { store } from './redux/store';
import { Router } from './Router';

export default function App() {
    return (
        <Provider store={store}>
            <ExternalAppProviders>
                <Router />
            </ExternalAppProviders>
        </Provider>
    );
}
